import { render, staticRenderFns } from "./topRecord.vue?vue&type=template&id=38871b2b&scoped=true&"
import script from "./topRecord.vue?vue&type=script&lang=js&"
export * from "./topRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38871b2b",
  null
  
)

export default component.exports